import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import './index.css';

const theme = createTheme({
  palette: {
    mode: 'light',
    // Colores oficiales de Guayerd según el manual de marca
    primary: {
      main: '#0C279F', // Azul Guayerd
      light: '#00CDFF', // Celeste Guayerd
      dark: '#0a1f7a',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#00F0B1', // Verde Guayerd
      light: '#33f5c4',
      dark: '#00c08a',
      contrastText: '#0C279F',
    },
    success: {
      main: '#00F0B1',
    },
    info: {
      main: '#00CDFF',
    },
    background: {
      default: '#f8f9fa',
      paper: '#ffffff',
    },
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 700, fontFamily: '"Viga", sans-serif' },
    h2: { fontWeight: 600, fontFamily: '"Viga", sans-serif' },
    h3: { fontWeight: 600, fontFamily: '"Viga", sans-serif' },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
          borderRadius: 10,
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #2E7BB4 0%, #194E83 100%)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          boxShadow: '0 8px 24px rgba(0,0,0,0.06)',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          height: 3,
          backgroundColor: '#2E7BB4',
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
